import { gsap } from 'gsap';
import MicroModal from 'micromodal';
import Cookies from 'js-cookie';
import jQuery from 'jquery';
import Video from './Video';
import { TimelineMax } from 'gsap';

const App = {
  // Core elements and properties
  $body: jQuery('body'),
  wWidth: jQuery(window).innerWidth(),
  wHeight: jQuery(window).innerHeight(),
  $window: jQuery(window),
  dataTrans: '', // name of transition
  previousDataTrans: '', // name of previous transition
  dataPage: '', // after using barba name of page
  pageType: '', // either primary or secondary page
  primaryPage: false,
  $curtain: jQuery('.curtain-call'),
  $chatContainer: jQuery('.chat-widget-container'),

  // Keyboard keys for scroll control
  keys: { 37: 1, 38: 1, 39: 1, 40: 1 }, // left: 37, up: 38, right: 39, down: 40, // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36

  // Check if device is mobile
  isMobile: function () {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        navigator.userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(
        navigator.userAgent.substr(0, 4)
      )
    ) {
      return true;
    }
    return false;
  },

  // URL handling methods
  getURLPath: function () {
    this.parsedUrl = new URL(window.location.href);
    return this.parsedUrl.pathname;
  },

  getRootURLPath: function () {
    this.parsedUrl = new URL(window.location.href);
    return this.parsedUrl.pathname.split('/')[1];
  },

  getExtendedURLPath: function () {
    this.parsedUrl = new URL(window.location.href);
    return this.parsedUrl.pathname;
  },

  searchPageUrl: function (findPage) {
    this.parsedUrl = new URL(window.location.href);
    let urlArray = this.parsedUrl.pathname.split('/');
    return urlArray.includes(findPage, 1);
  },

  searchPathNameArray: function (match) {
    // Used to find say 'product' in /store/product/2019...
    let pathArray = window.location.pathname.split('/');
    let found = false;
    pathArray.find((el) => (el === match ? (found = true) : false));
    return found;
  },

  // Scroll control methods
  preventDefault: function (e) {
    e = e || window.event;
    if (e.preventDefault) {
      e.preventDefault();
      e.returnValue = false;
    }
  },

  preventDefaultForScrollKeys: function (e) {
    if (this.keys[e.keyCode]) {
      e.preventDefault();
      return false;
    }
  },

  disableScroll: function () {
    if (window.addEventListener) {
      window.addEventListener('DOMMouseScroll', this.preventDefault, {
        passive: false,
      });
      document.addEventListener('wheel', this.preventDefault, {
        passive: false,
      });
      document.addEventListener('touchmove', this.preventDefault, {
        passive: false,
      });
      window.onwheel = this.preventDefault;
      window.onmousewheel = document.onmousewheel = this.preventDefault;
      window.ontouchmove = this.preventDefault;
      document.onkeydown = this.preventDefaultForScrollKeys.bind(this);
    }
  },

  enableScroll: function () {
    if (window.removeEventListener) {
      window.removeEventListener('DOMMouseScroll', this.preventDefault, {
        passive: false,
      });
      document.removeEventListener('wheel', this.preventDefault, {
        passive: false,
      });
      document.removeEventListener('touchmove', this.preventDefault, {
        passive: false,
      });
      window.onmousewheel = document.onmousewheel = null;
      window.onwheel = null;
      window.ontouchmove = null;
      document.onkeydown = null;
    }
  },

  // Cookie handling methods
  setCookie: function (name, value, days) {
    let expires = '';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
  },

  getCookie: function (name) {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },

  eraseCookie: function (name) {
    document.cookie = name + '=; Max-Age=-99999999;';
  },

  // Query string parser
  parseQuery: function (queryString) {
    let query = {};
    let pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
    for (let i = 0; i < pairs.length; i++) {
      let pair = pairs[i].split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
    return query;
  },

  // Animation methods - using GSAP
  curtainBottomToTop: function () {
    const curtainBT = gsap.timeline({ paused: true });
    curtainBT
      .set(jQuery('.curtain-call'), {
        top: 'inherit',
        bottom: 0,
        force3D: true,
        ease: 'power2.inOut',
      })
      .to(jQuery('.curtain-call'), { duration: 0.7, height: '100vh', force3D: true });

    curtainBT.play();
  },

  curtainTopToBottom: function () {
    const curtainTB = gsap.timeline({ paused: true });
    curtainTB
      .set(jQuery('.curtain-call'), {
        bottom: 'inherit',
        top: 0,
        force3D: true,
        ease: 'power2.inOut',
      })
      .to(jQuery('.curtain-call'), { duration: 0.7, height: '0vh', force3D: true });

    curtainTB.play();
  },

  // Age Gate functionality
  ageGateTL: new TimelineMax({ paused: true }),

  ageGateDrag: function () {
    // Set up age gate functionality
    this.statusModal();

    // Handle age gate confirmation button
    jQuery('.agegate-confirm').on('click', function () {
      App.hideAgeGate();
    });

    // Handle age gate skip button
    jQuery('.agegate-confirm-skip').on('click', function () {
      Cookies.set('over21', true, { expires: 90 });
    });
  },

  hideAgeGate: function () {
    // Animation to hide the age gate
    this.ageGateTL
      .to(
        [
          '.agegate-logo,#agegate .inner-container,.agegate-footer, .agegate-notification, .ageGate-logo-link',
        ],
        1,
        { autoAlpha: 0 }
      )
      .to(
        ['#agegate-background'],
        2.5,
        {
          autoAlpha: 0,
          scale: 1.3,
          transformOrigin: '50% 50%',
          ease: 'power3.inOut',
        },
        '-=.5'
      )
      .to(['#agegate'], 0.75, { autoAlpha: 0, ease: 'power3.inOut' }, '-=.1');

    this.ageGateTL
      .play()
      .eventCallback('onStart', function () {
        Video.initHeroVideo();
        // Load videos now
        Video.homeVideoSelectiveLoad();
      })
      .eventCallback('onComplete', function () {
        Cookies.set('over21', true, { expires: 90 });
      });
  },

  // Status modal handling
  statusModal: function () {
    const openEl = document.querySelectorAll('.open-status');

    if (openEl.length) {
      MicroModal.init({
        disableScroll: true,
        closeTrigger: 'data-micromodal-close',
      });

      openEl.forEach((item) => {
        item.addEventListener('click', (event) => {
          event.preventDefault();
          MicroModal.show('status-modal');
        });
      });
    }
  },

  // Utility method for padding numbers
  pad: function (num, size) {
    return ('000000000' + num).substr(-size);
  },

  // Store pre-filter in session storage
  preFilterCollections: function () {
    jQuery(document).on(
      {
        click: function (e) {
          let filter = jQuery(this).attr('data-filter');
          sessionStorage.setItem('preFilter', filter);
        },
      },
      '.pre-filter'
    );
  },

  // Set CSS variable for viewport height (vh)
  setCSSvariable: function () {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight / 100}px`);
  },

  // Handle header banner
  headerBanner: function () {
    const alertBanner = document.querySelector('.alert-banner');
    const mainNavigation = document.querySelector('.main-navigation');

    if (!alertBanner || !mainNavigation) return;

    // Function to update the top margin of the main navigation
    const updateNavigationMargin = () => {
      if (alertBanner) {
        const bannerHeight = alertBanner.offsetHeight;
        mainNavigation.style.marginTop = bannerHeight + 'px';
      } else {
        mainNavigation.style.marginTop = '0';
      }
    };

    if (alertBanner) {
      mainNavigation.classList.add('banner-active');
      updateNavigationMargin();
    }

    // Update margin on window resize
    window.addEventListener('resize', updateNavigationMargin);

    // Binding click event to alert banner
    document.addEventListener('click', (e) => {
      if (e.target.closest('.alert-banner')) {
        const bannerLink = e.target.closest('.alert-banner').querySelector('a').href;
        window.location = bannerLink;
      }
    });
  },

  // Method to handle special event modal
  initSpecialEventModal: function () {
    const showSpecialEventModal = () => {
      const now = new Date();
      const today = now.toDateString();
      const lastShownDate = Cookies.get('specialEventModalLastShownDate');

      console.log('Special Event Modal: Checking if modal should show');
      console.log('Today:', today);
      console.log('Last shown date:', lastShownDate);

      if (lastShownDate !== today) {
        console.log('Showing special event modal');
        try {
          // Initialize MicroModal first
          MicroModal.init({
            onShow: (modal) => console.log('Modal shown:', modal.id),
            onClose: (modal) => console.log('Modal closed:', modal.id),
            openTrigger: 'data-micromodal-trigger',
            closeTrigger: 'data-micromodal-close',
            disableScroll: true,
            disableFocus: false,
            awaitOpenAnimation: false,
            awaitCloseAnimation: false,
          });

          // Then show the modal
          setTimeout(() => {
            MicroModal.show('special-event-modal');
            Cookies.set('specialEventModalLastShownDate', today, { expires: 1 });
          }, 500);
        } catch (e) {
          console.error('Error showing special event modal:', e);
        }
      } else {
        console.log('Modal already shown today, skipping');
      }
    };

    // Call the function directly instead of waiting for DOMContentLoaded
    showSpecialEventModal();
  },

  // Initialize resize event handlers
  initResizeHandlers: function () {
    let resizeTimer;
    const self = this;

    const resizeHandler = function () {
      self.wWidth = jQuery(window).width();
      self.wHeight = jQuery(window).height();
      self.setCSSvariable();
    };

    // Throttled resize handler
    const throttledResize = function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(resizeHandler, 300);
    };

    window.addEventListener('resize', throttledResize);
  },

  // Initialize the app
  init: function () {
    this.isMobile();

    // Check for scroll to top flag
    if (sessionStorage.getItem('scrollToTop') === 'true') {
      console.log('Scrolling to top due to session flag');
      window.scrollTo(0, 0);
      // Clear the flag
      sessionStorage.removeItem('scrollToTop');
    }

    // Special case for wines page coming from menu
    if (
      sessionStorage.getItem('fromMenuToWines') === 'true' &&
      window.location.pathname.includes('/wines')
    ) {
      console.log('Wines page loaded from menu - forcing scroll to top');
      window.scrollTo(0, 0);
      // Add a second scroll after a short delay to ensure it works
      setTimeout(() => {
        window.scrollTo(0, 0);
      }, 100);
      // Clear the flag
      sessionStorage.removeItem('fromMenuToWines');
    }

    this.preFilterCollections();
    this.headerBanner();
    this.initSpecialEventModal();

    // Initialize age gate if needed
    if (document.querySelector('#agegate')) {
      this.ageGateDrag();
    }

    // Set up resize handlers
    this.setCSSvariable();
    this.initResizeHandlers();
  },
};

export default App;
